// extracted by mini-css-extract-plugin
module.exports = {"quote":"QuoteBlock_quote__fRiAX"};